import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import confirmView from "ui/dialogs/confirm/confirm.handlebars";
import Template from "ui/Template";

export default class Confirm extends Dialog {
	constructor(question) {
		super({
			title: i18n('title.confirm'),
			content: new Template(confirmView).createElement({message: question}),
			showTitle: false,
			smallWidth: true,
			buttons: [
				{
					caption: i18n('buttons.yes'),
					role: 'yes'
				},
				{
					caption: i18n('buttons.no'),
					role: 'no'
				}
			]
		});

		/**
		 * @type {function(flag: boolean): void}
		 * @private
		 */
		this._resolve = null;
	}

	/**
	 * @return {Promise<boolean>}
	 */
	async getResult() {
		return new Promise(resolve => {
			this._resolve = resolve;
		});
	}

	/**
	 * @param {string} role
	 * @returns {void}
	 * @protected
	 */
	_handleButton(role) {
		this._resolve(role === 'yes');
		this.destroy();
	}
}
